import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { configureStore } from './store'
import { createBrowserHistory } from 'history';
import config from './Config'
import firebase from 'firebase';

firebase.initializeApp(config.firebaseConfig);

let history = createBrowserHistory();
let store = configureStore(history);

ReactDOM.render(<App store={store} history={history} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
